'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _fade = require('../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = [[1, 6, 0.88, 1, 4, 0.88], [3, 10, 0.84, 3, 10, 0.77], [10, 30, 0.81, 6, 10, 0.77], [14, 45, 0.75, 10, 18, 0.78], [19, 60, 0.70, 15, 20, 0.78]];

exports.default = {
  depthShadows: (0, _map2.default)(data, function (d) {
    return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _fade2.default)(_colors2.default.black, d[2]) + ',\n    0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _fade2.default)(_colors2.default.black, d[5]);
  })
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/settings/styles.js
// module id = 101
// module chunks = 0